import { render, staticRenderFns } from "./WageSupplement.DayOfHour.vue?vue&type=template&id=4a81f0cc&scoped=true"
import script from "./WageSupplement.DayOfHour.vue?vue&type=script&lang=js"
export * from "./WageSupplement.DayOfHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81f0cc",
  null
  
)

export default component.exports